module.exports = __webpack_public_path__ + "static/img/smoke_d.953acf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smoke_d.png
// module id = 63l2
// module chunks = 208